import { Injectable, Type, inject } from '@angular/core';
import { NgbModal, NgbModalRef, NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmDialogComponent, IConfirmOptions } from '../components/confirm-dialog/confirm-dialog.component';
import { LegalPanelComponent, LegalDoc } from '../components/legal-panel/legal-panel.component';

/** Servicio de modales y diálogos sobre la ruta actual (ng-bootstrap). En celular: pantalla completa / sheet. */
@Injectable({ providedIn: 'root' })
export class DialogService {

  private modal = inject(NgbModal);
  private offcanvas = inject(NgbOffcanvas);

  /* -------------------------------------------------------------------------- */
  /*                               ANCHOR confirm                                */
  /* -------------------------------------------------------------------------- */
  // region confirm
  async confirm(options: IConfirmOptions): Promise<boolean> {
    const ref = this.modal.open(ConfirmDialogComponent, {
      centered: true,
      windowClass: 'cr-modal-window cr-dialog-window',
      backdrop: true,
    });
    (ref.componentInstance as ConfirmDialogComponent).options = { layout: 'left', tone: 'danger', ...options };
    try {
      return !!(await ref.result);
    } catch {
      return false;
    }
  }

  /* -------------------------------------------------------------------------- */
  /*                                ANCHOR open                                  */
  /* -------------------------------------------------------------------------- */
  // region open
  open<T>(component: Type<T>, inputs: Partial<T> = {}, windowClass = ''): NgbModalRef {
    const ref = this.modal.open(component, { centered: true, windowClass: `cr-modal-window ${windowClass}`, scrollable: false });
    Object.assign(ref.componentInstance as object, inputs);
    return ref;
  }

  // region result
  async result<R>(ref: NgbModalRef): Promise<R | null> {
    try {
      return (await ref.result) as R;
    } catch {
      return null;
    }
  }

  /* -------------------------------------------------------------------------- */
  /*                                ANCHOR legal                                 */
  /* -------------------------------------------------------------------------- */
  // region legal
  legal(doc: LegalDoc): void {
    const ref = this.offcanvas.open(LegalPanelComponent, { position: 'end', panelClass: 'cr-legal-panel', ariaLabelledBy: 'legal-title' });
    (ref.componentInstance as LegalPanelComponent).doc.set(doc);
  }

  // region dismissAll
  dismissAll(): void {
    this.modal.dismissAll();
    this.offcanvas.dismiss();
  }
}
